import React from 'react'
import InputFill from '../form/InputFill'
import HeadingForm from '../elements/HeadingForm'
import Button from '../elements/Button'

import { useTranslation } from 'react-i18next'

const UpdatePassword = ({
    handleSubmit,
    form,
    handleInputChange,
    clearErrorField,
    errors,
}) => {
    const { t } = useTranslation()

    const fields = [
        {
            label: t('customerInfo.password'),
            name: 'userPassword',
            props: {
                type: 'password',
            },
        },
        {
            label: t('customerInfo.newPassword'),
            name: 'userNewPassword',
            props: {
                type: 'password',
            },
        },
        {
            label: t('customerInfo.confirmNewPassword'),
            name: 'confirmNewPassword',
            props: {
                type: 'password',
            },
        },
    ]

    return (
        <form className="container py-4 flex-1" onSubmit={handleSubmit}>
            <HeadingForm>{t('updatePassword.title')}</HeadingForm>

            <div className="row">
                {fields.map((field, index) => {
                    const Component = field.component || InputFill
                    return (
                        <div className="col-12 col-md-6 offset-md-3">
                            <Component
                                className="mt-6"
                                label={t(field.label)}
                                name={field.name}
                                value={form[field.name]}
                                error={errors[field.name]}
                                onChange={handleInputChange}
                                onFocus={() => clearErrorField(field.name)}
                                {...field.props}
                            />
                        </div>
                    )
                })}
                <div className="mt-8 col-12 col-md-6 offset-md-3">
                    <Button fullWidth>{t('button.agree')}</Button>
                </div>
            </div>
        </form>
    )
}

export default UpdatePassword
